import { Switch, Tooltip } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectIsIncVat,
  setVatPreference,
  VAT_PREFERENCE,
} from 'src/features/VatPreferenceSlice'
import styled from 'styled-components/macro'

/**
 * Purchasing-wide Ex/Inc VAT toggle. Writes one Redux slice; every Purchasing
 * tab reads the same preference, so figures switch instantly without a refetch
 * (APIs return both bases in one payload).
 */
const VatToggle = () => {
  const dispatch = useDispatch()
  const isIncVat = useSelector(selectIsIncVat)

  const label = isIncVat ? 'Inc VAT' : 'Ex VAT'

  return (
    <Wrapper data-testid='purchasing-vat-toggle'>
      <Tooltip title='Switch Purchasing figures between excluding and including VAT'>
        <ToggleRow>
          <Label>{label}</Label>
          <Switch
            aria-label={label}
            checked={isIncVat}
            onChange={checked =>
              dispatch(
                setVatPreference(
                  checked ? VAT_PREFERENCE.INC : VAT_PREFERENCE.EX,
                ),
              )
            }
          />
        </ToggleRow>
      </Tooltip>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
`

const ToggleRow = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`

const Label = styled.span`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  writing-mode: horizontal-tb;
`

export default VatToggle
